<template>
  <div class="home">
    <div class="clock-content">
      <div class="clock" v-if="currentTime">
        <Img src="/clock1.png" />
        <span>{{ currentTime }}</span>
      </div>
    </div>
    <ul :class="{ center: examList.length < 3 }" v-if="examList.length > 0">
      <li v-for="(item, index) in examList" :key="index">
        <p class="index">{{ index + 1 }}</p>
        <dl>
          <dt>考试：{{ item.name }}</dt>
          <dd>
            <label>考试时间：</label>
            <span>{{ item.start_time }}</span>
          </dd>
          <dd>
            <label>考试时长：</label>
            <span>{{ item.exam_duration }}分钟</span>
          </dd>
          <dd>
            <label>总分：</label>
            <span>{{ item.score }}分</span>
          </dd>
          <dd>
            <label>状态：</label>
            <span :class="timeCount_ >= item.start_timestamp * 1000 && item.end_timestamp * 1000 > timeCount_ ? 'status pendding' : 'status'">{{
              item.start_timestamp * 1000 > timeCount_ ? '未开始' : timeCount_ > item.end_timestamp * 1000 ? '已结束' : '考试中'
            }}</span>
          </dd>
        </dl>
        <Button class="btn-center">考试须知</Button>
        <Button
          class="btn-center shadow"
          v-if="timeCount_ >= item.start_timestamp * 1000 && item.end_timestamp * 1000 > timeCount_"
          type="primary"
          @click="examStart(item)"
          :loading="loading === item.id"
          >开始考试</Button
        >
      </li>
    </ul>
    <p class="nodata" v-else>当前暂无考试数据</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: null, // 当前加载中的数据id按钮
      examList: [],
      timeCount: 0, // 当前时间戳
      currentTime: '' // 当前时间
    }
  },
  computed: {
    timeCount_() {
      return this.timeCount - 1000
    }
  },
  created() {
    this.getList()
    this.getServertime()
  },
  methods: {
    // 获取列表
    async getList() {
      const params = {
        uriCode: 'API003'
      }
      const res = await this.$fetch(params)
      this.examList = res.list
    },
    // 开始考试
    async examStart(obj) {
      const param = {
        uriCode: 'API010',
        examination_id: obj.id
      }
      try {
        this.loading = obj.id
        const res = await this.$fetch(param)
        this.$router.push({ name: 'exam', params: { eeid: res.eeid, paper_id: res.exam_paper_id }, query: { end_timestamp: res.valid_timestamp } })
      } finally {
        this.loading = null
      }
    },
    // 获取服务器时间
    async getServertime() {
      const params = {
        uriCode: 'API002'
      }
      const res = await this.$fetch(params)
      this.timeCount = res.server_time * 1000
      this.getTime()
    },
    // 当前时间
    getTime() {
      const timer = setInterval(() => {
        const hours = new Date(this.timeCount).getHours()
        const minutes = new Date(this.timeCount).getMinutes()
        const seconds = new Date(this.timeCount).getSeconds()
        const h = hours < 10 ? '0' + hours : hours
        const m = minutes < 10 ? '0' + minutes : minutes
        const s = seconds < 10 ? '0' + seconds : seconds
        this.currentTime = h + ':' + m + ':' + s //修改数据date
        this.timeCount += 1000
      }, 1000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(timer)
      })
    }
  }
}
</script>

<style lang="scss">
.home {
  width: 100%;
  height: 100%;
  min-height: 100%;
  padding: 50px 0;
  box-sizing: border-box;
  position: relative;
  background-color: #f2f7fb;
  &.center {
    align-items: center;
  }
  .nodata {
    font-size: 16px;
    text-align: center;
    margin-top: 200px;
  }
  .clock-content {
    width: 100%;
    margin-bottom: 50px;
    height: 60px;
  }
  .clock {
    width: 180px;
    height: 60px;
    line-height: 60px;
    border-radius: 11px;
    display: flex;
    background-color: #007aff;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    padding: 0 10px;
    box-sizing: content-box;
    img {
      width: 32px;
      height: 32px;
      margin-right: 14px;
    }
    span {
      font-size: 30px;
      // font-family: DINAlternate-Bold, DINAlternate;
      // font-weight: bold;
      color: #fff;
    }
  }
  ul {
    width: 1220px;
    height: calc(100% - 110px);
    overflow-y: auto;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    &.center {
      justify-content: center;
      li {
        &:last-child {
          margin-right: 0;
        }
      }
    }
    li {
      width: 388px;
      height: 457px;
      margin-right: 20px;
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      padding: 90px 70px 47px;
      text-align: center;
      position: relative;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
      &:nth-of-type(n + 4) {
        margin-top: 20px;
      }
      .index {
        width: 45px;
        height: 45px;
        text-align: center;
        line-height: 45px;
        font-size: 21px;
        color: #fff;
        position: absolute;
        left: 0;
        top: 0;
        font-weight: bold;
      }
      &:nth-of-type(odd) {
        .index {
          background-color: #007aff;
        }
      }
      &:nth-of-type(even) {
        .index {
          background-color: #00d586;
        }
      }
      dl {
        margin-bottom: 65px;
      }
      dt {
        font-size: 18px;
        color: #333;
        text-align: center;
        margin-bottom: 37px;
        font-weight: 600;
      }
      dd {
        color: #717886;
        display: flex;
        margin-top: 5px;
        line-height: 22px;
        span {
          color: #3b3d41;
          font-weight: 500;
        }
        .status {
          display: block;
          width: 60px;
          height: 22px;
          background: #c5c7d0;
          box-shadow: 0px 2px 4px 0px rgba(155, 174, 214, 0.27);
          border-radius: 11px;
          text-align: center;
          line-height: 22px;
          color: #fff;
          &.pendding {
            background: #00d586;
          }
        }
      }
      label {
        display: block;
        width: 90px;
        text-align: right;
        color: #717886;
      }
      .btn-center {
        margin-top: 10px !important;
        width: 128px !important;
        height: 39px !important;
        line-height: 37px !important;
      }
    }
  }
}
</style>
